import { Injectable } from '@angular/core'
import { ToastService as SharedToastService } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class ToastService extends SharedToastService {}
